<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Email Template</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/emailtemplates/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
    </main>
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/EmailTemplates/MenuList.vue";
import lang from "@/views/modules/EmailTemplates/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/EmailTemplates/ListView.vue";
import CustomSearch from "@/views/modules/EmailTemplates/SearchView.vue";
    export default {
        name: "new-email-template",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive:false,
                metaList: [
                    {
                        label: lang.LBL_TEMPLATE_NAME,
                        link: true,
                        moduleName: 'EmailTemplates',
                        routePath: 'emailtemplates',
                        linkOtherModule:false,
                        isSort:true,
                        field_name:'name',
                    
                    },
                    {
                        label: lang.LBL_ENTERED,
                        link: false,
                        moduleName: '',
                        routePath: '',
                        linkOtherModule:false,
                        isSort:true,
                        field_name:'date_entered',
                    
                    },
                    
                ],
                columns: ['name', 'date_entered'],
            }
        },
        mounted() {
            this.childMethod();
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns);
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>